import { useSelector } from 'react-redux';
import type { RootState } from 'redux/types';
import useFeatureFlag from '../../hooks/useFeatureFlag';
import { useIsFreemiumOnboardingUser } from '../../hooks/useIsFreemiumOnboardingUser';
import useIsStudentUser from '../../hooks/useIsStudentUser';
import { FEATURE_FLAGS } from '../../constants/FeatureFlag';
import { OnboardingAddressStatus } from './types';
import { isOnboardingAddressSkipped } from './onboardingAddressSkip';

export function useOnboardingAddress(): { status: OnboardingAddressStatus } {
  const user = useSelector((state: RootState) => state.auth.user);
  const { isFeatureFlagEnable: enableRequestAddress, flagResolved } =
    useFeatureFlag(FEATURE_FLAGS.KILL_SWITCH.ENABLE_REQUEST_ADDRESS);
  const { isFreemium, isResolved: isFreemiumResolved } =
    useIsFreemiumOnboardingUser();
  // Aluno não entra aqui: o cadastro pago já coleta o endereço. Precisa ser
  // explícito: o aluno pago não é "restrito", então com o NewOnboarding ligado
  // ele também conta como freemium.
  const { isStudent } = useIsStudentUser();

  const status: OnboardingAddressStatus = (() => {
    if (!flagResolved || !isFreemiumResolved) {
      return 'loading';
    }

    if (
      !user?.should_fill_data ||
      !enableRequestAddress ||
      !isFreemium ||
      isStudent ||
      isOnboardingAddressSkipped(user?.id)
    ) {
      return 'ineligible';
    }

    return 'ready';
  })();

  return { status };
}
